import { getAwsDomainUrl } from '../../../utils/generateURL';
import { IWTButton } from '../IWTButton';

export const ManageSavedPaymentMethodsIWT = () => {
  const manageSavedPaymentLink = `${getAwsDomainUrl(
    window.location.hostname
  )}/payments/manage-saved-payment-methods?referrer=managemembership`;
  
  return (
    <IWTButton
      title="Manage saved payment methods"
      id="ManageSavedPaymentMethodsIWT"
      onClick={() => {
        window.location.assign(manageSavedPaymentLink);
      }}
    />
  );
};
